module.exports = __webpack_public_path__ + "static/media/053.138e8115.png";